import { Route, Routes } from "react-router-dom";
import { Routes as ContactRoutes } from "./routes";
import { ContactRouterCmp } from "./types";

import { ContactDetailPage } from "../pages/ContactDetailPage";
import { ContactSearchPage } from "../pages/ContactSearchPage";
import { ContactEmailSearchPage } from "../pages/ContactDetailPage/components/ContactDetailCard/components/ContactEmailSearchPage";
import { ContactPhoneSearchPage } from "../pages/ContactDetailPage/components/ContactDetailCard/components/ContactPhoneSearchPage";
import { ContactAddressSearchPage } from "../pages/ContactDetailPage/components/ContactDetailCard/components/ContactAddressSearchPage";
import { ContactNoteSearchPage } from "../pages/ContactDetailPage/components/ContactDetailCard/components/ContactNoteSearchPage";
import { ContactRepresentativeSearchPage } from "../pages/ContactDetailPage/components/ContactDetailCard/components/ContactRepresentativeSearchPage";


// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ContactRouter: ContactRouterCmp = () => {
  return (
    <>
      <Routes>
        <Route path={ContactSearchPage.route} element={<ContactSearchPage />} />
        <Route path={ContactDetailPage.route} element={<ContactDetailPage />} />
        <Route path={ContactEmailSearchPage.route} element={<ContactEmailSearchPage />} />
        <Route path={ContactPhoneSearchPage.route} element={<ContactPhoneSearchPage />} />
        <Route path={ContactAddressSearchPage.route} element={<ContactAddressSearchPage />} />
        <Route path={ContactNoteSearchPage.route} element={<ContactNoteSearchPage />} />
        <Route path={ContactRepresentativeSearchPage.route} element={<ContactRepresentativeSearchPage />} />
      </Routes>
    </>
  );
};

ContactRouter.route = ContactRoutes.ContactRouter;

export default ContactRouter;
